module.exports = __webpack_public_path__ + "static/media/icon-12w.4274fe79.svg";